import { useContext, useCallback } from 'react';
import { SmartCardContext } from '@atlaskit/link-provider';
import { SOURCE } from '@atlassian/jira-invite-prompt-on-link-insert/src/services/feature-flag/index.tsx';
import { useInvitePrompt as useInvitePromptExp } from '@atlassian/jira-invite-prompt-on-link-insert/src/ui/index.tsx';
import { getAllProductLinks } from '@atlassian/jira-invite-prompt-on-link-insert/src/utils/index.tsx';
import type { GeneralFieldValue } from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

export const useInvitePrompt = (projectKey?: string) => {
	const cloudId = useCloudId();
	const { cloudName } = useTenantContext();
	const triggerInviteExperiment = useInvitePromptExp(projectKey);
	const { store } = useContext(SmartCardContext) || {};

	return useCallback(
		async (description: GeneralFieldValue) => {
			if (description && store && projectKey) {
				const links = getAllProductLinks(description, store, cloudId, cloudName);
				for (const [link, data] of Object.entries(links)) {
					// https://eslint.org/docs/latest/rules/no-await-in-loop#when-not-to-use-it
					/* eslint-disable no-await-in-loop */
					if (await triggerInviteExperiment(link, data, SOURCE.CREATE_ISSUE)) return;
				}
			}
		},
		[cloudId, cloudName, projectKey, store, triggerInviteExperiment],
	);
};
